import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';
import * as tpaGfppData from '../tpaGfppDataActions';
import type { GFPPDataRaw } from '@wix/editor-component-types';

const gfppData: GFPPDataRaw = {
  mainActions: tpaGfppData.mainActions,
  enabledActions(editorAPI: EditorAPI) {
    return tpaGfppData.enabledActions(
      editorAPI,
      constants.ROOT_COMPS.GFPP.ACTIONS,
    );
  },
  presetActions(editorAPI: EditorAPI) {
    return tpaGfppData.presetActions(editorAPI);
  },
  mobileMainActions: tpaGfppData.mobileMainActions,
  mobileEnabledActions: [constants.ROOT_COMPS.GFPP.ACTIONS.HELP],
} as unknown as GFPPDataRaw;

export default gfppData;
